import React from 'react';
import CostingRunPage, { procurementCostingConfig } from '../shared/CostingRunPage';

// Procurement > Costing — runs the implosion and the procurement pricing procs,
// then shows the resulting prices and anything the run had to guess at.
// The page itself lives in shared/CostingRunPage.jsx; Manufacturing > Costing is
// the same component with a different config.
const ProcurementCosting = () => <CostingRunPage config={procurementCostingConfig} />;

export default ProcurementCosting;
